import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ContragentTypeEnum, MtrTypeEnum } from 'gql/graphql';

import { useMemo } from 'react';

import { updateMtrToWorkOrderFromPriceListGql } from '../workOrderQueries';

interface IPriceListMtrRowUpdateInput {
    justification: number;
    mtrRowId: number;
    mtrType: MtrTypeEnum;
    supplyBy: ContragentTypeEnum;
    unitCost: number;
    unitWeight: number;
}
interface IUseUpdateMtrToWorkOrderFromPriceListProps {
    workOrderPriceId?: number;
    input?: IPriceListMtrRowUpdateInput;
    withEffect: boolean;
}

export const useUpdateMtrToWorkOrderFromPriceList = (props: IUseUpdateMtrToWorkOrderFromPriceListProps) => {
    const { workOrderPriceId, input, withEffect } = props;
    const variables = useMemo(() => ({ workOrderPriceId, input }), [workOrderPriceId, input]);

    const [
        updateMtrToWorkOrderFromPriceListResponse,
        updateMtrToWorkOrderFromPriceListStatus,
        updateMtrToWorkOrderFromPriceListError,
        updateMtrToWorkOrderFromPriceListRequest,
    ] = useRequest({
        requestId: 'updateMtrToWorkOrderFromPriceList',
        query: updateMtrToWorkOrderFromPriceListGql,
        // @ts-ignore
        variables,
        withEffect: Boolean(workOrderPriceId) && withEffect,
    });

    const [resetMtrUpdateData] = useResetStoreData({ requestId: 'updateMtrToWorkOrderFromPriceList' });

    return {
        updateMtrToWorkOrderFromPriceListResponse,
        updateMtrToWorkOrderFromPriceListStatus,
        updateMtrToWorkOrderFromPriceListError,
        updateMtrToWorkOrderFromPriceListRequest,
        resetMtrUpdateData,
    };
};
